import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=613541a1&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"
import style0 from "./FooterView.vue?vue&type=style&index=0&id=613541a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.39_css-loader@6.11.0_webpack@5.108.3_postcss@8_0c092578831b3ed3444609d5c956d95e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613541a1",
  null
  
)

export default component.exports